export const SuccessNotificationObj = (title: string, message: string, id?: string) => {
  return {
    ...GeneralNotificationSettings,
    title: title,
    message: message,
    color: "var(--color-success-primary)",
    id: id,
  };
};

export const ErrorNotificationObj = (title: string, message: string, id?: string) => {
  return {
    ...GeneralNotificationSettings,
    title: title,
    message: message,
    color: "var(--color-error-primary)",
    id: id,
  };
};

export const InfoNotificationObj = (title: string, message: string) => {
  return {
    ...GeneralNotificationSettings,
    title: title,
    message: message,
    color: "var(--color-background-primary)",
  };
};

const GeneralNotificationSettings = {
  autoClose: 4000,
};
